export {
  getTelNummberLink,
  getTelNummber,
} from '../Basepage/parts/HeaderMoluna/overrides';

export function CSSInjection() {
  return `
  /*
  div.Kalenderliebling {
    background-color: rgb(242, 242, 242);
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    //align-items: stretch;
  }
  
  div.Kalenderliebling img.ProductImage {
    max-width: 150px;
    margin: 10px 15px;
    object-fit: contain;
  }
  
  div.Kalenderliebling div.center {
    text-align: justify;
    padding-right: 50px;
  }
  
  div.Kalenderliebling div.center span {
    display: flex;
    font-weight: bold;
  }
  
  div.Kalenderliebling div.center span.Title {
    font-size: x-large;
  }
  
  div.Kalenderliebling div.center span.Price {
    display: inline-block;
    //float: right; 
  }
  
  div.Kalenderliebling span.header {
    font-size: xx-large;
    color: #8a0808;
  }
  
  
  
  @media only screen and (max-width: 767px) {
    div.Kalenderliebling {
      flex-direction: column;
    }
  }
  */
  a:link:not(.activeLink),
  #navEZPagesTOC ul li a {
    color: #000;
    text-decoration: none;
  }
  `;
}
